import { useContext } from "react";
import { AttachmentsIndexContextValue } from "./types";
import { AttachmentsIndexContext } from "./contexts";

export const useAttachmentsIndexContext = (): AttachmentsIndexContextValue => {
  const context = useContext(AttachmentsIndexContext);
  if (!context) {
    throw new Error("useHandlerContext must be used within a HandlerProvider");
  }
  return context;
};
